<template>
    <base-modal :closable="closable" :adaptive="true" height="auto" width="100%" :max-width="600" :name="name">
       <div class="py-10">
            <div class="px-4 text-center">

                <h1 class="mb-6 text-2xl md:text-3xl">
                    {{ computedHeading }}
                </h1>
                <p class="mb-6">
                    {{ computedIngress }}
                </p>

                <div class="text-center leading-normal">

                    <button class="btn-primary btn mx-2 mb-2" @click="show('login-modal')">
                        {{ _('modal.login_register_required.login_button') }}
                    </button>

                    <button class="btn-primary btn mx-2 mb-2" @click="show('register-modal')">
                        {{ _('modal.login_register_required.register_button') }}
                    </button>

                </div>

                <div v-if="!disableBypass && bypassHref && bypassLabel" class="mt-4">
                    <a :href="bypassHref" class="btn btn-trans-primary btn-small mx-2 mb-2">
                        {{ bypassLabel }}
                    </a>
                </div>

            </div>
        </div>
    </base-modal>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'

    export default {

        props: {
            name: {
                required: false,
                default: 'login-to-continue-modal',
            },
            closable: {
                type: Boolean,
                default: true,
            },
            heading: {
                type: String,
                default: "default",
            },
            ingress: {
                type: String,
                default: "default",
            },
            disableBypass: {
                type: Boolean,
                default: false,
            },
            bypassHref: {
                type: String,
                default: null,
            },
            bypassLabel: {
                type: String,
                default: null,
            },
        },

        data() {
            return {
                modalName: "login-to-continue-modal"
            }
        },

        computed: {
            ...mapGetters('general', ['_', 'getPath']),

            computedHeading() {
                return this.heading === "default" ? this._('modal.login_register_required.headline') : this._(this.heading);
            },

            computedIngress() {
                return this.ingress === "default" ? this._('modal.login_register_required.textheadline') : this._(this.ingress);
            }
        },

        methods: {
            ...mapMutations('modal', ["showModal", "hideModal"]),
            show(name) {
                this.showModal(name);
                this.hideModal(this.modalName);
            }
        }
    }
</script>
